import LazyLoad from 'vanilla-lazyload';
export default {
  init() {
    let menuMobile = document.querySelector('.menu__trigger');
    let menu = document.querySelector('.header__nav-container');

    menuMobile.addEventListener('click', (e) => {
      menuMobile.classList.toggle('opened');
      menu.classList.toggle('opened');
    });

    new LazyLoad({
      elements_selector: 'img[srcset]',
      use_native: true,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js